<template>
  <div class="nortic-input">
    <label
      class="validate-input"
      :class="{ ...problemClasses, 'has-prefix': hasPrefix, focus: isHighlighted, 'is-disabled': isDisabled }"
    >
      <div
        v-if="hasPrefix"
        class="prefix"
      >
        <slot
          name="prefix"
        />
      </div>
      <input
        :id="htmlId"
        ref="input"
        v-model="innerValue"
        v-mask="mask"
        :style="customInputStyle"
        :masked="!!mask"
        :placeholder="placeholder"
        v-bind="$attrs"
        data-inheritattrs
        :type="type"
        :maxlength="maxLengthOrFalse"
        @keypress="emitKeypressEvent"
        @keyup="emitKeyUpEvent"
        @keydown="emitKeyDownEvent"
        @change="emitChangeEvent"
        @focus="emitFocusEvent"
        @blur="emitBlurEvent"
      >
      <div
        v-if="hasSuffix"
        class="suffix"
      >
        <slot
          name="suffix"
        />
      </div>
      <div
        v-if="(normalizedValidatorResult.isDirty && isValidatorBoxVisible) || maxlength"
        class="input-info"
      >
        <span
          v-if="normalizedValidatorResult.isDirty"
          class="validator-icon"
          :class="problemClasses"
        >
          <SvgIcon :data="validatorIcon" />
        </span>
        <span
          v-if="maxlength"
          class="remaining-chars"
        >
          {{ remainingChars }}
        </span>
      </div>
    </label>
  </div>
</template>

<script>
import textInput from '@/components/common/input/mixins/textInput';
import validator from '@/components/common/input/mixins/validator';

export default {
  name: 'NorticTextInput',
  mixins: [textInput, validator],
  inheritAttrs: false,
  props: {
    customInputStyle: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    hasSuffix() {
      return !!this.$slots.suffix;
    },
    hasPrefix() {
      return !!this.$slots.prefix;
    },
    isDisabled() {
      return this.$attrs.disabled === '' || this.$attrs.disabled;
    },
  },
  methods: {
    emitKeypressEvent(e) {
      this.$emit('keypress', e);
    },
    emitKeyUpEvent(e) {
      this.$emit('keyup', e);
    },
    emitKeyDownEvent(e) {
      this.$emit('keydown', e);
    },
    emitChangeEvent(e) {
      this.$emit('change', e);
    },
    emitFocusEvent(e) {
      this.$emit('focus', e);
    },
    emitBlurEvent(e) {
      this.$emit('blur', e);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/components/common/input/style/_style.scss';

  .nortic-input {
    display: grid;

    label {
      &.has-prefix {
        grid-template-columns: auto 1fr auto auto;
      }

      &.is-disabled {
        opacity: 0.5;
      }

      grid-template-columns: 1fr auto auto;
      display: grid;
      font-size: 1em;
      border-radius: 3px;
      transition: all 0.2s linear;

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        appearance: none;
        margin: 0;
      }

      input[type=number] {
        appearance: none;
      }

      input {
        &::placeholder {
          color: var(--input-alt-text-hex);
        }

        &:focus {
          &::placeholder {
            opacity: 0.5;
          }
        }

        height: 40px;
        padding: 0 10px;
        border: 0;
        background-color: transparent;
        box-sizing: border-box;
        width: 100%;
        font-size: 1em;
        color: var(--input-text-hex);

        @media screen and (max-width: $mediumLargeBreakpoint) {
          width: 100%;
        }
      }

      .prefix {
        padding: 0 5px 0 10px;
        display: grid;
        align-items: center;
      }

      .suffix {
        display: grid;
        align-items: center;
        padding: 0 10px 0 0;
      }

      .input-info {
        display: grid;
        justify-items: end;
        align-items: end;
        min-width: 30px;
        padding: 0 10px 0 0;

        .remaining-chars {
          padding: 2px;
          right: 0;
          bottom: -15px;
          font-size: 12px;
          font-weight: 700;
          color: var(--input-alt-text-hex);
        }

        .validator-icon {
          &.warn {
            color: var(--warn-text-alt-color-hex);
          }

          &.danger {
            color: var(--danger-text-alt-color-hex);
          }

          height: 100%;
          color: var(--success-text-alt-color-hex);
          display: grid;
          align-items: center;
          font-size: calc(100% + 5px);
        }
      }
    }

    .validator-message {
      justify-self: end;
      height: 1em;
      max-height: 1em;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 5px 0;
      line-height: 1em;
      font-size: 14px;
      color: var(--danger-text-alt-color-hex);
      white-space: nowrap;
      max-width: 100%;
    }
  }
</style>
